import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminCustomers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { (async () => {
    try { const { data } = await api.get("/admin/customers"); setUsers(data); } catch {}
  })(); }, []);

  return (
    <div data-testid="admin-customers">
      <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">People</p>
      <h1 className="font-serif text-4xl mb-8">Customers</h1>
      <div className="bg-white border border-black/5">
        <table className="w-full text-sm">
          <thead className="text-left text-[11px] uppercase tracking-nav text-[#7A7A7A] border-b border-black/5">
            <tr><th className="px-4 py-3">Name</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Role</th><th className="px-4 py-3">Signed up</th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} className="border-b border-black/5">
                <td className="px-4 py-3">{u.name}</td>
                <td className="px-4 py-3">{u.email}</td>
                <td className="px-4 py-3">{u.role}</td>
                <td className="px-4 py-3 font-mono-alt text-xs">{u.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
